/**
 * @generated SignedSource<<4f8174278eb7420d4b65f501bb556305>>
 * @relayHash 95f6669992cbe1238f2b09a9780e53d7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2b1858a27268c1166616b348844600bedc63c3ca13448a7d7b0e1afd50ef42ea

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GrowthUnifiedProfileRollingDateIntervalInput = "DAYS_1" | "DAYS_180" | "DAYS_270" | "DAYS_30" | "DAYS_365" | "DAYS_7" | "DAYS_90" | "%future added value";
export type OnboardingHubPageComponentQuery$variables = {
  cloudId: string;
  insightsEnabled: boolean;
  rollingIntervals: ReadonlyArray<GrowthUnifiedProfileRollingDateIntervalInput>;
};
export type OnboardingHubPageComponentQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"InsightsPanel" | "OnboardingListTable">;
};
export type OnboardingHubPageComponentQuery = {
  response: OnboardingHubPageComponentQuery$data;
  variables: OnboardingHubPageComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "insightsEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rollingIntervals"
},
v3 = [
  {
    "kind": "ScalarField",
    "name": "date"
  },
  {
    "kind": "ScalarField",
    "name": "value"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "OnboardingHubPageComponentQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "OnboardingListTable"
      },
      {
        "condition": "insightsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "InsightsPanel"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "OnboardingHubPageComponentQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "JiraOnboardingConfigConnection",
        "kind": "LinkedField",
        "name": "jira_onboardingConfigs",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraOnboardingConfigEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraOnboardingConfig",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "onboardingConfigAri"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "targetValues"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "updatedAt"
                  },
                  {
                    "concreteType": "JiraOnboardingModal",
                    "kind": "LinkedField",
                    "name": "modals",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraOnboardingStep",
                        "kind": "LinkedField",
                        "name": "steps",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraOnboardingLink",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__typename"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "insightsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "tenantId",
                "variableName": "cloudId"
              }
            ],
            "concreteType": "GrowthUnifiedProfileSiteProfileResult",
            "kind": "LinkedField",
            "name": "growthUnifiedProfile_siteProfile",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "rollingIntervals",
                    "variableName": "rollingIntervals"
                  }
                ],
                "concreteType": "GrowthUnifiedProfileSiteOnboardingInsightsResult",
                "kind": "LinkedField",
                "name": "onboardingHubInsightsOverAll",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "totalViews"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "totalEngagements"
                  },
                  {
                    "concreteType": "GrowthUnifiedProfileEngagementsSeries",
                    "kind": "LinkedField",
                    "name": "engagementsSeries",
                    "plural": true,
                    "selections": (v3/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "name": "rollingInterval"
                  },
                  {
                    "concreteType": "GrowthUnifiedProfileViewSeries",
                    "kind": "LinkedField",
                    "name": "viewsSeries",
                    "plural": true,
                    "selections": (v3/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "name": "completionRate"
                  },
                  {
                    "concreteType": "GrowthUnifiedProfileCompletionSeries",
                    "kind": "LinkedField",
                    "name": "completionsSeries",
                    "plural": true,
                    "selections": (v3/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2b1858a27268c1166616b348844600bedc63c3ca13448a7d7b0e1afd50ef42ea",
    "metadata": {},
    "name": "OnboardingHubPageComponentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1dfbf25107ad675ecd6b2ea633e0fb2b";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
